import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Error401: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
            <div className="bg-white p-6 rounded-lg shadow-md text-center max-w-md mx-auto">
                <p className="text-lg text-gray-800 mb-4">
                    {t('error.401.bodyText')}
                </p>
                <Link to="/" className="text-blue-500 hover:underline">
                    {t('error.401.goHomeLink')}
                </Link>
            </div>
        </div>
    );
};

export default Error401;